import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorEspIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementos por página:';
  override nextPageLabel = 'página siguiente';
  override previousPageLabel = 'página anterior';
  override firstPageLabel = 'primera página';
  override lastPageLabel = 'ultima página';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `Página 1 de 1`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const lengthStr = `${length}`;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    const start = `${startIndex + 1}`.padStart(lengthStr.length, '0');
    const end = `${endIndex}`.padStart(lengthStr.length, '0');
    const amountPages = Math.ceil(length / pageSize);
    const amountPagesStr = `${amountPages}`;
    const pageIndex = `${page + 1}`.padStart(amountPagesStr.length, '0');
    return `Página  ${pageIndex} de ${amountPages} (ítems ${start} a ${end} de ${length})`;
  };
}
